var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { staticClass: "box" }, [
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Administrar usuario"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Areas")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-body" }, [
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [
                _vm._v("Seleccióne el area"),
              ]),
              _vm._v(" "),
              _c(
                "b-select",
                {
                  attrs: { expanded: "" },
                  model: {
                    value: _vm.selectedArea,
                    callback: function ($$v) {
                      _vm.selectedArea = $$v
                    },
                    expression: "selectedArea",
                  },
                },
                [
                  _c(
                    "option",
                    {
                      attrs: { selected: "", disabled: "" },
                      domProps: { value: null },
                    },
                    [_vm._v("- Seleccione el area -")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.areasDisponibles, function (option) {
                    return _c(
                      "option",
                      { key: option.id, domProps: { value: option.id } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.nombre) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [
                _vm._v("Defina el cargo en el area"),
              ]),
              _vm._v(" "),
              _c("b-input", {
                attrs: {
                  type: "text",
                  placeholder: "Cargo",
                  disabled: !_vm.selectedArea,
                  expanded: "",
                },
                model: {
                  value: _vm.cargo,
                  callback: function ($$v) {
                    _vm.cargo = $$v
                  },
                  expression: "cargo",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "buttons is-right" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary",
            attrs: {
              disabled: !_vm.selectedArea && _vm.cargo === null && false,
            },
            on: {
              click: function ($event) {
                return _vm.agregarArea(_vm.selectedArea)
              },
            },
          },
          [_c("i", { staticClass: "fas fa-plus" }), _vm._v(" Asignar")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("h3", { staticClass: "title is-5" }, [_vm._v("Areas asignadas")]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _vm.usuario.areas.length
          ? _c(
              "b-field",
              { attrs: { grouped: "", "group-multiline": "" } },
              _vm._l(_vm.usuario.areas, function (area) {
                return _c(
                  "div",
                  { key: area.id, staticClass: "control" },
                  [
                    _c(
                      "b-taglist",
                      { attrs: { attached: "" } },
                      [
                        _c(
                          "b-tag",
                          { attrs: { type: "is-dark", size: "is-medium" } },
                          [_vm._v(_vm._s(area.nombre))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tag",
                          {
                            attrs: {
                              type: "is-light",
                              size: "is-medium",
                              closable: "",
                            },
                            on: {
                              close: function ($event) {
                                return _vm.quitarArea(area.id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(area.pivot.cargo) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            )
          : _c("p", { staticClass: "is-mono" }, [
              _vm._v("- El usuario no tiene areas registradas - "),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v("Elija el área, describa su cargo (opcional) y haga clic en "),
        _c("span", { staticClass: "tag is-primary" }, [_vm._v("Asignar")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Puede eliminar cualquiera de los registros haciendo clic en el boton "
        ),
        _c("i", { staticClass: "fas fa-times-circle has-text-primary" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }